import styled from "styled-components";
import { Space } from "task-eva-ui";

export const PlatformNoticeWrapper = styled(Space)`
  padding: 20px;
  max-width: 480px;
  white-space: pre-wrap;
  word-break: break-word;
  text-align: start;
  font-size: 14px;
`;

export const PlatformNoticeModalWrapper = styled.div`
  .common-modal-wrapper {
    padding-bottom: 0;
  }
`;
